import { createAction } from 'redux-actions';

export default {
    AddNotificationHistory: createAction('ADD_NOTIFICATION_HISTORY'),
    UpdateUnread: createAction('UPDATE_UNREAD'),
    UpdateNumberOfNotifs: createAction('UPDATE_NOTIFS'),
    UpdateImageLoad: createAction('UPDATE_IMAGE_LOAD'),
};
